"use client";
import { Box, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { faClose, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/styles";

interface InputProps {
  label?: string;
  error?: boolean;
  search?: boolean;
  clearSearch?: boolean;
  errorText?: string;
  style?: React.CSSProperties;
  register?: any;
  options?: Object;
  name: string;
  helperText?: string;
  placeHolder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clearSearchFunction?: any;
  borderRadius?: string;
  value?: string | number;
  type?:
    | "text"
    | "number"
    | "email"
    | "password"
    | "file"
    | "date"
    | "textarea";
  multiLineRows?: number;
  height?: string;
  minHeightWidthForIcon?: boolean;
}

export function VeSearch({
  label,
  error,
  search,
  clearSearch,
  errorText,
  style,
  name,
  register,
  value,
  helperText,
  placeHolder,
  multiLineRows = undefined,
  onChange,
  height,
  clearSearchFunction,
  minHeightWidthForIcon = false,
  borderRadius,
}: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState("");

  const handleClearSearch = () => {
    if (clearSearchFunction) {
      clearSearchFunction();
    }
    setInputValue("");
  };

  return (
    <Box width={"100%"} sx={{ ...style }}>
      <TextField
        sx={{
          "& .MuiOutlinedInput-input": {
            height: height || "8px",
            paddingLeft: minHeightWidthForIcon
              ? "0px"
              : search
                ? "4px"
                : "16px",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: borderRadius || "4px",
          },
        }}
        ref={inputRef}
        fullWidth
        {...(register && register(name))}
        error={error}
        placeholder={placeHolder}
        name={name}
        value={value}
        label={label}
        multiline={!!multiLineRows}
        onKeyDown={(e) => {
          // 🔥 blocks event from bubbling up to the parent
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (onChange) {
            onChange(e);
          }
          setInputValue(e.target.value);
        }}
        rows={multiLineRows || undefined}
        helperText={(error && errorText) || helperText}
        InputProps={{
          startAdornment: search && (
            <InputAdornment position="start">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                height={minHeightWidthForIcon ? 9 : "100%"}
                width={minHeightWidthForIcon ? 9 : "auto"}
              />
            </InputAdornment>
          ),
          endAdornment: clearSearch && inputValue && (
            <InputAdornment
              sx={{ cursor: "pointer" }}
              onClick={handleClearSearch}
              position="end"
            >
              <FontAwesomeIcon icon={faClose} />
            </InputAdornment>
          ),
        }}
      />
      {/* {errorText && <FieldError error={errorText} />} */}
    </Box>
  );
}
